import React, { useState, useEffect, useRef } from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Box, Grid, TextField, MenuItem, Typography } from '@material-ui/core'
import { systemsService } from '../../Services/SystemsService/SystemsService'
import { useStyles } from './style'
import { FlexibleXYPlot, XAxis, YAxis, VerticalBarSeries, LineSeries, Crosshair, LabelSeries, MarkSeries } from 'react-vis'
import {
  makeXTickValue,
  processGraphData,
  getOneDayParsedData,
  getCustomParsedData,
  getYearParsedData,
  getLifetimeParsedData,
  getEmptyGraphData,
  getYScale,
  processDayGraphData,
  convertUnits,
} from './utils'
import Switch from './Switch'
import { ENERGY_TYPE, CUSTOM_TYPE } from './constant'
import CustomCrosshair from './CustomCrosshair'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import calendarIcon from '../../Assets/Images/calendarIcon.svg'
import arrowLeft from '../../Assets/Images/arrowLeft.svg'
import arrowRight from '../../Assets/Images/arrowRight.svg'


function SystemGraph(props) {
  const classes = useStyles()

  const outerRef = useRef(null)

  const { eventsData } = props

  const [eventDataSelectedDay, setEventDataSelectedDay] = useState([])
  const [calendarDate, setCalendarDate] = useState(new Date())
  const [startCalendarDate, setStartCalendarDate] = useState(calendarDate)
  const [endCalendarDate, setEndCalendarDate] = useState(calendarDate)
  const [showCalendar, setShowCalendar] = useState(false)
  const [graphData, setGraphData] = useState({})
  const [xValues, setXValues] = useState([])
  const [customType, setCustomType] = useState(CUSTOM_TYPE.DAY)
  const [yDomain, setYDomain] = useState({})
  const [batteryData, setBatteryData] = useState([])
  const [graphConstructedData, setConstructedData] = useState([])
  const [positiveGraphData, setPositiveData] = useState(getEmptyGraphData(graphConstructedData, xValues, customType))
  const [negativeGraphData, setNegativeData] = useState(getEmptyGraphData(graphConstructedData, xValues, customType))
  const [crosshairValues, setCrossHairValues] = useState([])
  const [showEventDetails, setShowEventDetails] = useState(false)
  const [eventDisplayDetails, setEventDisplayDetails] = useState({})

  const [trackButtons, setTrackButtons] = useState({
    production: true,
    consumption: true,
    importExport: true,
    battery: true
  })
  const shouldDisplayNext = moment(calendarDate, 'MM-DD-YYYY').isBefore(moment(new Date(), 'MM-DD-YYYY'), 'day')
  const shouldDisplayNextWeek = moment(calendarDate, 'MM-DD-YYYY').isBefore(moment(new Date(), 'MM-DD-YYYY').startOf('isoWeek'), 'day')
  const shouldDisplayNextMonth = moment(calendarDate, 'MM-DD-YYYY').isBefore(moment(new Date(), 'MM-DD-YYYY').startOf('month'), 'day')
  const shouldDisplayNextYear = moment(calendarDate, 'MM-DD-YYYY').isBefore(moment(new Date(), 'MM-DD-YYYY').startOf('year'), 'day')
  const tileDisabled = ({ activeStartDate, date, view }) => {
    return date.getDay() !== 1
  }

  const handleOuterClick = (e) => {
    if (outerRef.current != null && !outerRef.current.contains(e.target)) {
      setShowCalendar(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleOuterClick)

    return () => {
      document.removeEventListener('mousedown', handleOuterClick)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const positiveMargin = {
    bottom: 30,
    left: 45,
    right: 15,
    top: 50
  }
  const energyNegative = {
    top: 50,
    right: 15,
    bottom: 30,
    left: 45,
  }

  const batteryMargin = {
    top: 10,
    right: 15,
    bottom: 10,
    left: 45,
  }
  const axisStyle = {
    ticks: {
      fontSize: '10px',
      fill: '#a1aab3',
    },
    line: {
      stroke: '#a1aab3',
    },
    title: {
      fontSize: '10px',
      fill: '#7b8793'
    },
  }

  const xAxisStyle = {
    ticks: {
      fontSize: '10px',
      fill: '#a1aab3',
    },
    title: {
      fontSize: '10px',
      fill: '#7b8793'
    },
  }

  const yDomainBatteryStatus = {
    min: 0,
    max: 100
  }

  const changeCalendarDate = (e) => {
    setCalendarDate(e)
    setStartCalendarDate(e)
    setEndCalendarDate(e)
  }
  const changeCalendarWeek = (e) => {
    setCalendarDate(moment(e).startOf('isoWeek').toDate())
    setStartCalendarDate(moment(e).startOf('isoWeek').toDate())
    setEndCalendarDate(moment(e).endOf('isoWeek').toDate())
  }

  const changeCalendarMonth = (e) => {
    setCalendarDate(moment(e).startOf('month').toDate())
    setStartCalendarDate(moment(e).startOf('month').toDate())
    setEndCalendarDate(moment(e).endOf('month').toDate())
  }
  const changeCalendarYear = (e) => {
    setCalendarDate(moment(e).startOf('year').toDate())
    setStartCalendarDate(moment(e).startOf('year').toDate())
    setEndCalendarDate(moment(e).endOf('year').toDate())
  }
  const prevDayChange = (e) => {
    setCalendarDate(moment(calendarDate).subtract(1, 'day').toDate())
    setStartCalendarDate(moment(startCalendarDate).subtract(1, 'day').toDate())
    setEndCalendarDate(moment(endCalendarDate).subtract(1, 'day').toDate())
  }
  const nextDayChange = (e) => {
    setCalendarDate(moment(calendarDate).add(1, 'day').toDate())
    setStartCalendarDate(moment(startCalendarDate).add(1, 'day').toDate())
    setEndCalendarDate(moment(endCalendarDate).add(1, 'day').toDate())
  }
  const prevWeekChange = (e) => {
    setCalendarDate(moment(calendarDate).subtract(1, 'week').toDate())
    setStartCalendarDate(moment(startCalendarDate).subtract(1, 'week').toDate())
    setEndCalendarDate(moment(endCalendarDate).subtract(1, 'week').toDate())
  }
  const nextWeekChange = (e) => {
    setCalendarDate(moment(calendarDate).add(1, 'week').toDate())
    setStartCalendarDate(moment(startCalendarDate).add(1, 'week').toDate())
    setEndCalendarDate(moment(endCalendarDate).add(1, 'week').toDate())
  }
  const prevMonthChange = (e) => {
    setCalendarDate(moment(calendarDate).subtract(1, 'month').toDate())
    setStartCalendarDate(moment(startCalendarDate).subtract(1, 'month').toDate())
    setEndCalendarDate(moment(endCalendarDate).subtract(1, 'month').toDate())
  }
  const nextMonthChange = (e) => {
    setCalendarDate(moment(calendarDate).add(1, 'month').toDate())
    setStartCalendarDate(moment(startCalendarDate).add(1, 'month').toDate())
    setEndCalendarDate(moment(endCalendarDate).add(1, 'month').toDate())
  }
  const prevYearChange = (e) => {
    setCalendarDate(moment(calendarDate).subtract(1, 'year').toDate())
    setStartCalendarDate(moment(startCalendarDate).subtract(1, 'year').toDate())
    setEndCalendarDate(moment(endCalendarDate).subtract(1, 'year').toDate())
  }
  const nextYearChange = (e) => {
    setCalendarDate(moment(calendarDate).add(1, 'year').toDate())
    setStartCalendarDate(moment(startCalendarDate).add(1, 'year').toDate())
    setEndCalendarDate(moment(endCalendarDate).add(1, 'year').toDate())
  }

  const changeCalendarDisplay = (e) => {
    setShowCalendar(true)
  }

  const handleSwitch = (obj) => {
    buildGraphData(graphData, obj)
    setTrackButtons(obj)
  }

  const trackSwitch = (obj, switchObj) => {
    switch (obj.key) {
      case ENERGY_TYPE.PRODUCTION.SNO:
        return switchObj.production
      case ENERGY_TYPE.CONSUMPTION.SNO:
        return switchObj.consumption
      case ENERGY_TYPE.IMPORTED.SNO:
      case ENERGY_TYPE.EXPORTED.SNO:
        return switchObj.importExport
      case ENERGY_TYPE.BATTERY_CHARGED.SNO:
      case ENERGY_TYPE.BATTERY_DISCHARGED.SNO:
        return switchObj.battery
      default:
        return false
    }
  }

  const getSelectedDateEvents = () => {
    let eventDataSelectedDayTemp = [...eventDataSelectedDay]

    eventsData && eventsData.map(event => {
      if ((moment(event.start_time).tz(props.timeZone).format('ddd MMM DD YYYY') === moment(calendarDate).tz(props.timeZone).toDate().toDateString()) || (moment(event.end_time).tz(props.timeZone).format('ddd MMM DD YYYY') === moment(calendarDate).tz(props.timeZone).toDate().toDateString())) {
        let today = moment().tz(props.timeZone)
        let eventStartDateConversion = moment(event.start_time).tz(props.timeZone).set({ 'year': today.get('year'), 'month': today.get('month'), 'date': today.get('date') })
        let eventStartTime = (moment(new Date(eventStartDateConversion.format('YYYY-MM-DD HH:mm:ss'))).toDate().getTime() / 1000).toFixed(0)
        let eventEndDateConversion = moment(event.end_time).tz(props.timeZone).set({ 'year': today.get('year'), 'month': today.get('month'), 'date': today.get('date') })
        let eventEndTime = (moment(new Date(eventEndDateConversion.format('YYYY-MM-DD HH:mm:ss'))).toDate().getTime() / 1000).toFixed(0)
        let eventObject = {
          startTime: eventStartTime,
          endTime: eventEndTime,
          name: event.name
        }

        var index = eventDataSelectedDayTemp.findIndex(x => x.startTime == eventStartTime || x.endTime == eventStartTime || x.startTime == eventEndTime || x.endTime == eventEndTime)

        if (index === -1) {
          eventDataSelectedDayTemp.push({
            startTime: moment(event.start_time).tz(props.timeZone).format('DD') == moment(calendarDate).tz(props.timeZone).format('DD') && eventStartTime,
            endTime: moment(event.end_time).tz(props.timeZone).format('DD') == moment(calendarDate).tz(props.timeZone).format('DD') && eventEndTime,
            name: event.name
          })
        }
      }
    })
    if (eventDataSelectedDayTemp.length != 0) {
      setEventDataSelectedDay(eventDataSelectedDayTemp)
    }

  }
  useEffect(() => {
    setEventDataSelectedDay([])
  }, [eventsData, calendarDate])

  useEffect(() => {
    if (eventDataSelectedDay.length === 0) {
      getSelectedDateEvents()
    }
  }, [eventDataSelectedDay])

  const buildGraphData = (response, switchObj) => {
    let constructedData = {}
    let xAxisTickValueEnergy = []
    let yDomainEnergy = {}
    let batteryGraphData = []

    if (customType === CUSTOM_TYPE.DAY) {
      const stats = _.get(response, 'stats', [])
      const newData = getOneDayParsedData(stats[0] || {})
      constructedData = processGraphData(newData)
      xAxisTickValueEnergy = makeXTickValue(constructedData)
      yDomainEnergy = getYScale(constructedData)
      batteryGraphData = _.get(constructedData, 'battery_status', [])
    }
    else if (customType === CUSTOM_TYPE.MONTH) {
      const startDate = _.get(response, 'start_date', '')
      const initalDate = moment(startCalendarDate).startOf('month')
      const diff = initalDate.diff(startDate, 'days')
      const length = moment(initalDate).startOf('month').add(1, 'month').diff(moment(initalDate), 'days', [])
      const newData = getCustomParsedData(response, diff, length)
      constructedData = processDayGraphData(newData, initalDate, customType)
      xAxisTickValueEnergy = makeXTickValue(constructedData, customType)
      yDomainEnergy = getYScale(constructedData)
    } else if (customType === CUSTOM_TYPE.YEAR) {
      const startDate = _.get(response, 'start_date', '')
      const initalDate = moment(startCalendarDate).startOf('year')
      const diff = initalDate.diff(startDate, 'days')

      const newData = getYearParsedData(response, diff, initalDate)
      constructedData = processDayGraphData(newData, initalDate, customType)
      xAxisTickValueEnergy = makeXTickValue(constructedData, customType)
      yDomainEnergy = getYScale(constructedData)
    } else if (customType === CUSTOM_TYPE.LIFETIME) {
      const startDate = _.get(response, 'start_date', '')
      const initalDate = moment(startDate).startOf('year')
      const diff = initalDate.diff(startDate, 'days')
      const totalYears = moment(new Date()).diff(initalDate, 'years')
      const newData = getLifetimeParsedData(response, diff, initalDate, totalYears)
      constructedData = processDayGraphData(newData, initalDate, customType)
      xAxisTickValueEnergy = makeXTickValue(constructedData, customType)
      yDomainEnergy = getYScale(constructedData)
    } else {
      const startDate = _.get(response, 'start_date', '')
      const initalDate = moment(startCalendarDate).startOf('isoWeek')
      const diff = initalDate.diff(startDate, 'days')
      const length = moment(initalDate).startOf('isoWeek').add(1, 'week').diff(moment(initalDate), 'days', [])
      const newData = getCustomParsedData(response, diff, length)
      constructedData = processDayGraphData(newData, initalDate, customType)
      xAxisTickValueEnergy = makeXTickValue(constructedData, customType)
      yDomainEnergy = getYScale(constructedData)
    }

    const production = _.get(constructedData, 'production', [])
    const consumption = _.get(constructedData, 'consumption', [])
    const imported = _.get(constructedData, 'imported', [])
    const exported = _.get(constructedData, 'exported', [])
    const battery_discharged = _.get(constructedData, 'battery_discharged', [])
    const battery_charged = _.get(constructedData, 'battery_charged', [])
    const generator = _.get(constructedData, 'generator', [])
    let energyDataCurrentPositiveMaster = _.union(production, imported, battery_discharged, generator)
    let energyDataCurrentNegativeMaster = _.union(consumption, exported, battery_charged)
    const energyDataCurrentPositive = _.chain(energyDataCurrentPositiveMaster)
      .filter(obj => {
        return trackSwitch(obj, switchObj)
      })
      .sortBy('x').sortBy('key').value()
    const energyDataCurrentNegative = _.chain(energyDataCurrentNegativeMaster)
      .filter(obj => {
        return trackSwitch(obj, switchObj)
      }).sortBy('x').sortBy('key').value()

    setPositiveData(energyDataCurrentPositive)
    setNegativeData(energyDataCurrentNegative)
    setXValues(xAxisTickValueEnergy)
    setYDomain(yDomainEnergy)
    setBatteryData(batteryGraphData)
    setConstructedData(constructedData)
  }

  useEffect(() => {
    if (customType === CUSTOM_TYPE.DAY) {
      props.accountId && props.siteId && systemsService.getSystemsDailyGraph(props.accountId, props.siteId, true, moment(startCalendarDate).format('DD-MM-YYYY'), moment(endCalendarDate).format('DD-MM-YYYY'))
        .then((response) => {
          setGraphData(response)
        })
        .catch(err => {
        })
    }
    else {
      props.accountId && props.siteId && systemsService.getSystemsLifetimeGraph(props.accountId, props.siteId, false)
        .then((response) => {
          setGraphData(response)
        })
        .catch(err => {
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.accountId, props.siteId, customType, calendarDate])

  useEffect(() => {
    graphData && buildGraphData(graphData, trackButtons)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [graphData, startCalendarDate, endCalendarDate])

  const handleDurationChange = (e) => {
    setCustomType(e.target.value)
    changeCalendarDate(new Date())
  }

  const changeShowEventDetails = (eventDetails, showEventDetailsCheck) => {
    setShowEventDetails(showEventDetailsCheck)
    setEventDisplayDetails(eventDetails)
  }

  const getXTickFormat = (timestamp, index) => {
    const date = moment.unix(timestamp).clone()
    if (customType === CUSTOM_TYPE.DAY) {
      return date.format('h A').toString()
    } else if (customType === CUSTOM_TYPE.MONTH) {
      return date.format('D').toString()
    } else if (customType === CUSTOM_TYPE.WEEK) {
      return date.format('DD/MM/YYYY').toString()
    } else if (customType === CUSTOM_TYPE.YEAR) {
      return date.format('MMM').toString()
    } else {
      return date.format('YYYY').toString()
    }
  }

  const getYTickFormat = (value, index, scale, tickTotal) => {
    let yAxisValue = `${scale.tickFormat(tickTotal, 's')(Math.abs(value))}`
    const newyYAxisValue = yAxisValue ? Number(yAxisValue) : yAxisValue
    const yAxisPrefix = isNaN(newyYAxisValue) ? yAxisValue[yAxisValue.length - 1] : null
    yAxisValue = isNaN(newyYAxisValue) ? yAxisValue.substring(0, yAxisValue.length - 1) : yAxisValue

    if (yAxisPrefix === null || yAxisPrefix === '') {
      yAxisValue /= 1000
    }
    const isDecimal = (yAxisValue !== null && yAxisValue.toString().indexOf('.') !== -1)
    yAxisValue = isDecimal ? parseFloat(Number(yAxisValue)).toFixed(2) : yAxisValue
    yAxisValue = isDecimal && yAxisValue == 0 ? yAxisValue.replace(/.00/, '') : yAxisValue
    return yAxisValue
  }

  const onMouseLeave = () => {
    setCrossHairValues([])
    setEventDisplayDetails()
    setShowEventDetails(false)
  }

  const onNearestX = (value, event) => {
    const indexVal = (event.index || event.index === 0) ? event.index : -1
    const selectedData = {}
    if (indexVal > -1) {
      _.each(graphConstructedData, (kValue, key) => {
        selectedData[key] = {}
        const obj = _.find(kValue, val => val.x === value.x)
        selectedData[key] = convertUnits(obj ? obj.y : 0, 'wattHours')
        selectedData[key].x = value.x
        selectedData[key].key = key
      })

      setCrossHairValues([
        selectedData.production,
        selectedData.consumption,
        selectedData.imported,
        selectedData.exported,
        selectedData.net_energy,
        selectedData.battery_charged,
        selectedData.battery_discharged,
        selectedData.battery_status,
        selectedData.generator,
      ])
    }
  }


  return (
    <Box py={2}>
      <div className={classes.graphHeaderWrapper}>
        <Grid container spacing={2} alignItems="center" justify="space-between">
          <Grid item md={6}>
            <span className={classes.smallerFont}>System Energy Overview</span>
          </Grid>
        </Grid>
      </div>
      <Box mt={2}>
        <div className={classes.labelWrapper}>
          <Switch handleSwitch={handleSwitch} />
          <Grid item md={2}>
            <TextField
              id="1"
              fullWidth
              select
              label="View Data"
              size="small"
              value={customType}
              onChange={handleDurationChange}
              InputProps={{
                classes: { root: classes.select }
              }}
              SelectProps={{
                MenuProps: {
                  classes: { paper: classes.paper },
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                  },
                  getContentAnchorEl: null
                }
              }}
            >
              <MenuItem value={CUSTOM_TYPE.DAY}>Day</MenuItem>
              <MenuItem value={CUSTOM_TYPE.WEEK}>Week</MenuItem>
              <MenuItem value={CUSTOM_TYPE.MONTH}>Month</MenuItem>
              <MenuItem value={CUSTOM_TYPE.YEAR}>Year</MenuItem>
              <MenuItem value={CUSTOM_TYPE.LIFETIME}>LifeTime</MenuItem>
            </TextField>

            {customType === CUSTOM_TYPE.DAY &&
              <>
                <div className={classes.dateRangeWrapper}>
                  <div className={classes.sideArrowBar} onClick={prevDayChange}>
                    <div className={classes.arrowIcon}><ArrowBackIosIcon /></div>
                  </div>
                  <div className={classes.dateRange} onClick={changeCalendarDisplay}>
                    <img src={calendarIcon} />
                    <Typography className={classes.dateRangeContent}>{moment(calendarDate).format('DD/MM/YYYY')}</Typography>
                  </div>
                  {shouldDisplayNext ? <div className={classes.sideArrowBar} onClick={nextDayChange}>
                    <div className={classes.arrowIcon}><ArrowForwardIosIcon /></div>
                  </div> : <div></div>}
                </div>
                {showCalendar ?
                  <div className={classes.calendarWrapper} ref={outerRef}>
                    <Calendar className={classes.calendar} showNeighboringMonth={true} defaultValue={calendarDate} onChange={changeCalendarDate} view={CUSTOM_TYPE.MONTH} maxDate={new Date()} prevLabel={<img src={arrowLeft} />} prev2Label={null} next2Label={null} nextLabel={<img src={arrowRight} />} />
                  </div> :
                  <></>
                }
              </>
            }
            {customType === CUSTOM_TYPE.WEEK &&
              <>
                <div className={classes.dateRangeWrapper}>
                  <div className={classes.sideArrowBar} onClick={prevWeekChange}>
                    <div className={classes.arrowIcon}><ArrowBackIosIcon /></div>
                  </div>
                  <div className={classes.dateRange} onClick={changeCalendarDisplay}>
                    <img src={calendarIcon} />
                    <Typography className={classes.dateRangeContent}>{moment(calendarDate).startOf('isoWeek').format('DD MMM')} - {moment(calendarDate).endOf('isoWeek').format('DD MMM')}</Typography>
                  </div>
                  {shouldDisplayNextWeek ? <div className={classes.sideArrowBar} onClick={nextWeekChange}>
                    <div className={classes.arrowIcon}><ArrowForwardIosIcon /></div>
                  </div> : <div></div>}
                </div>
                {showCalendar ?
                  <div className={classes.calendarWrapper} ref={outerRef}>
                    <Calendar className={classes.calendar} value={calendarDate} onChange={changeCalendarWeek} view={CUSTOM_TYPE.MONTH} maxDate={new Date()} tileDisabled={tileDisabled} prevLabel={<img src={arrowLeft} />} prev2Label={null} next2Label={null} nextLabel={<img src={arrowRight} />} />
                  </div> :
                  <></>
                }
              </>
            }
            {customType === CUSTOM_TYPE.MONTH &&
              <>
                <div className={classes.dateRangeWrapper}>
                  <div className={classes.sideArrowBar} onClick={prevMonthChange}>
                    <div className={classes.arrowIcon}><ArrowBackIosIcon /></div>
                  </div>
                  <div className={classes.dateRange} onClick={changeCalendarDisplay}>
                    <img src={calendarIcon} />
                    <Typography className={classes.dateRangeContent}>{moment(calendarDate).format('MMM YYYY')}</Typography>
                  </div>
                  {shouldDisplayNextMonth ? <div className={classes.sideArrowBar} onClick={nextMonthChange}>
                    <div className={classes.arrowIcon}><ArrowForwardIosIcon /></div>
                  </div> : <div></div>}
                </div>
                {showCalendar ?
                  <div className={classes.calendarWrapper} ref={outerRef}>
                    <Calendar className={classes.calendar} value={calendarDate} onChange={changeCalendarMonth} onClickMonth={changeCalendarMonth} view={CUSTOM_TYPE.YEAR} maxDate={new Date()} prevLabel={<img src={arrowLeft} />} prev2Label={null} next2Label={null} nextLabel={<img src={arrowRight} />} />
                  </div> :
                  <></>
                }
              </>
            }
            {customType === CUSTOM_TYPE.YEAR &&
              <>
                <div className={classes.dateRangeWrapper}>
                  <div className={classes.sideArrowBar} onClick={prevYearChange}>
                    <div className={classes.arrowIcon}><ArrowBackIosIcon /></div>
                  </div>
                  <div className={classes.dateRange} onClick={changeCalendarDisplay}>
                    <img src={calendarIcon} />
                    <Typography className={classes.dateRangeContent}>{moment(calendarDate).format('YYYY')}</Typography>
                  </div>
                  {shouldDisplayNextYear ? <div className={classes.sideArrowBar} onClick={nextYearChange}>
                    <div className={classes.arrowIcon}><ArrowForwardIosIcon /></div>
                  </div> : <div></div>}
                </div>
                {showCalendar ?
                  <div className={classes.calendarWrapper} ref={outerRef}>
                    <Calendar className={classes.calendar} style={{ zIndex: 2 }} value={calendarDate} onChange={changeCalendarYear} onClickYear={changeCalendarYear} view={CUSTOM_TYPE.LIFETIME} maxDate={new Date()} prevLabel={<img src={arrowLeft} />} prev2Label={null} next2Label={null} nextLabel={<img src={arrowRight} />} />
                  </div> :
                  <></>
                }
              </>
            }
          </Grid>
        </div>
        <div className={classes.graphContainer} style={{ height: 'auto', zIndex: 1 }}>
          <div className={classes.graphWrapper}>
            <FlexibleXYPlot
              stackBy='y'
              xType="linear"
              margin={positiveMargin}
              onMouseLeave={onMouseLeave}
            >
              <XAxis
                tickValues={xValues}
                tickFormat={(...args) => getXTickFormat(...args)}
                style={axisStyle}
                hideTicks={true}
              />
              <YAxis
                title={'kWh'}
                yDomain={[yDomain.min, yDomain.max]}
                orientation="left"
                position="end"
                tickTotal={5}
                tickFormat={(...args) => getYTickFormat(...args)}
                style={axisStyle}
              />
              <VerticalBarSeries
                yDomain={[yDomain.min, yDomain.max]}
                opacity="literal"
                colorType="literal"
                stroke="literal"
                data={positiveGraphData}
                onNearestX={onNearestX}
                style={{ position: 'relative' }}
              />
              {customType === CUSTOM_TYPE.DAY && eventDataSelectedDay &&
                eventDataSelectedDay.map((event) =>
                  event.startTime &&
                  <LineSeries stroke='#6AC13B' strokeStyle='dashed' data={[{ x: event.startTime, y: 0 }, { x: event.startTime, y: yDomain.max }]}>
                  </LineSeries>
                )
              }
              {customType === CUSTOM_TYPE.DAY && showEventDetails && eventDisplayDetails?.startTime &&
                <LabelSeries allowOffsetToBeReversed data={[{ x: eventDisplayDetails?.startTime, y: yDomain.max, label: `${eventDisplayDetails?.name} Started `, xOffset: -5, yOffset: 20, style: { fontSize: 12, fill: '#7e7e7e' } }]}>
                </LabelSeries>
              }
              {customType === CUSTOM_TYPE.DAY && eventDataSelectedDay &&
                eventDataSelectedDay.map((event) =>
                  event.startTime &&
                  <MarkSeries stroke='#6AC13B' onValueMouseOver={() => changeShowEventDetails(event, true)} onValueMouseOut={() => changeShowEventDetails(null, false)} fill='#6AC13B' size='4' data={[{ x: event.startTime, y: yDomain.max }]}>
                  </MarkSeries>
                )
              }
              {customType === CUSTOM_TYPE.DAY && eventDataSelectedDay &&
                eventDataSelectedDay.map((event) =>
                  event.endTime && event.startTime < event.endTime &&
                  <LineSeries stroke='#E25838' strokeStyle='dashed' data={[{ x: event.endTime, y: 0 }, { x: event.endTime, y: yDomain.max }]}>
                  </LineSeries>
                )
              }
              {customType === CUSTOM_TYPE.DAY && showEventDetails && eventDisplayDetails?.startTime < eventDisplayDetails?.endTime &&
                <LabelSeries allowOffsetToBeReversed labelAnchorX='start' labelAnchorY='end' data={[{ x: eventDisplayDetails?.endTime, y: yDomain.max, xOffset: 5, yOffset: -10, label: `${eventDisplayDetails?.name} Ended`, style: { fontSize: 12, fill: '#7e7e7e' } }]}>
                </LabelSeries>
              }
              {customType === CUSTOM_TYPE.DAY &&
                eventDataSelectedDay && eventDataSelectedDay.map((event) =>
                  event.endTime && event.startTime < event.endTime && <MarkSeries onValueMouseOver={() => changeShowEventDetails(event, true)} onValueMouseOut={() => changeShowEventDetails(null, false)} stroke='#E25838' fill='#E25838' size='4' data={[{ x: event.endTime, y: yDomain.max }]}>
                  </MarkSeries>
                )
              }
              {positiveGraphData && <Crosshair values={crosshairValues} className={`${classes.crossHair} ${classes.positveCrossHair} ${customType !== CUSTOM_TYPE.DAY ? classes.negativeCrossHair : ''}`} >
                {customType === CUSTOM_TYPE.DAY && <CustomCrosshair
                  trackLegends={trackButtons}
                  period={customType}
                  data={crosshairValues}
                  willShowCrosshairContent={crosshairValues && crosshairValues.length > 0}
                  timeZone={props.timeZone}
                />}
              </Crosshair>}
            </FlexibleXYPlot>
          </div>
          <div className={classes.graphWrapper} style={{ marginTop: '-80px' }}>
            <FlexibleXYPlot
              stackBy="y"
              xType="linear"
              margin={energyNegative}
              onMouseLeave={onMouseLeave}
            >
              <XAxis
                tickValues={xValues}
                tickFormat={(...args) => getXTickFormat(...args)}
                style={xAxisStyle}
              />
              <YAxis
                yDomain={[-yDomain.max, yDomain.min]}
                orientation="left"
                position="end"
                tickTotal={5}
                tickFormat={(...args) => getYTickFormat(...args)}
                style={axisStyle}
              />

              <VerticalBarSeries
                yDomain={[-yDomain.max, yDomain.min]}
                opacity="literal"
                colorType="literal"
                stroke="literal"
                data={negativeGraphData}
                color="#f37320"
                onNearestX={onNearestX}
                style={{ position: 'relative' }}
              />
              {customType === CUSTOM_TYPE.DAY &&
                eventDataSelectedDay && eventDataSelectedDay.map((event) =>
                  event.startTime && <LineSeries stroke='#6AC13B' strokeStyle='dashed' data={[{ x: event.startTime, y: 0 }, { x: event.startTime, y: -yDomain.max }]}>
                  </LineSeries>)
              }
              {customType === CUSTOM_TYPE.DAY &&
                eventDataSelectedDay && eventDataSelectedDay.map((event) =>
                  event.endTime && event.startTime < event.endTime && <LineSeries stroke='#E25838' strokeStyle='dashed' data={[{ x: event.endTime, y: 0 }, { x: event.endTime, y: -yDomain.max }]}>
                  </LineSeries>
                )
              }
              <Crosshair values={crosshairValues} className={`${classes.crossHair} ${classes.negativeCrossHair}`} />
            </FlexibleXYPlot>
          </div>
        </div>
      </Box>
    </Box >
  )
}

export default SystemGraph